module.exports = __webpack_public_path__ + "img/img_12_retail@3x.eea37141.png";